import React from 'react';
import { MdClose } from 'react-icons/md';
import { MultiValueRemoveProps } from 'react-select/src/components/MultiValue';
import classNames from 'classnames';

import { Icon } from '../../icon';
import { InputClassProps } from '../../input-class-name.util';
import { Option } from '../option.model';

export const MultiValueRemove = ({
  height,
  innerProps,
}: MultiValueRemoveProps<Option> & InputClassProps) => (
  <div
    {...innerProps}
    className={classNames(
      'p-1 rounded text-primary-500 hover:bg-primary-100 cursor-pointer',
      {
        'p-0.5': height === 'sm',
        'p-1': height === 'md',
      }
    )}
  >
    <Icon icon={<MdClose />} />
  </div>
);
